module.exports = __webpack_public_path__ + "img/Medieval_Sword_EuropeanBroad.8b5fa50e.png";